/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Personal_TitleInputs */

const he_profile_personal_title = /** @type {(inputs: Profile_Personal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מידע אישי`)
};

const en_profile_personal_title = /** @type {(inputs: Profile_Personal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Information`)
};

/**
* | output |
* | --- |
* | "Personal Information" |
*
* @param {Profile_Personal_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const profile_personal_title = /** @type {((inputs?: Profile_Personal_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Personal_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_personal_title(inputs)
	return en_profile_personal_title(inputs)
});